import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="file" {...props} />;
}

export const meta = {
  id: 'CMSPAGESDetails',
  title: 'Page Details',
  category: 'CMS',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `<!-- TODO: add a description here! -->`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 780,
    height: 750
  }
};
